import {Injectable} from '@angular/core'
import {GraphqlLinkFactory} from './graphql-link.factory'
import {Apollo} from 'apollo-angular'

@Injectable({providedIn: 'root'})
export class GraphqlLinkController {
  private _getJwtToken?: () => Promise<string | undefined>

  constructor(
    private readonly factory: GraphqlLinkFactory,
    private readonly apollo: Apollo,
  ) {}

  addAuth(getJwtToken: () => Promise<string | undefined>) {
    this._getJwtToken = getJwtToken
    this.apollo.client.setLink(this.factory.build(getJwtToken))
  }

  async removeAuth() {
    await this.apollo.client.clearStore()
    this._getJwtToken = undefined
    this.apollo.client.setLink(this.factory.build(undefined))
  }

  async addPubSubSupport(): Promise<void> {
    const getJwtToken = this._getJwtToken?.bind(this)
    this.apollo.client.setLink(await this.factory.buildWithPubSub(getJwtToken))
  }
}
